const optionsToPaginationParams = (options = {}) => {
  const {sortBy, sortDesc, page = 1, itemsPerPage = 15} = options
  const limit = itemsPerPage
  const offset = (page - 1) * itemsPerPage
  const order =
    sortBy && sortBy.length > 0 && sortDesc.length > 0
      ? JSON.stringify([[sortBy[0], sortDesc[0] ? 'DESC' : 'ASC']])
      : undefined
  return {limit, offset, order}
}

export {optionsToPaginationParams}
